import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {DynamicButtonContent} from 'shells/dynamic-button-content/dynamic-button-content';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

type Props = {
    buttonText: string | React.ReactNode;
    buttonRef: any;
};

export function AiButtonContent(props: Props) {
    const {buttonText, buttonRef} = props;

    const ButtonContent = (contentProps: {icon: React.ReactNode}) => (
        <StackLegacy spacing={8} alignCenter={true} isHorizontal={true}>
            <div className='flex align-center'>{contentProps.icon}</div>
            <div>{buttonText}</div>
        </StackLegacy>
    );

    return (
        // @ts-expect-error
        <DynamicButtonContent
            buttonRef={buttonRef}
            defaultContent={
                <ButtonContent
                    icon={<AiSparkleNewIcon size={15} wrapWithDiv={false} fill={colors.white} />}
                />
            }
            hoverContent={
                <ButtonContent
                    icon={<AiSparkleNewIcon size={15} wrapWithDiv={false} fill={colors.white} />}
                />
            }
        />
    );
}
